import React from 'react';
import './Header.css'

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import FolderIcon from '@material-ui/icons/PermContactCalendar';
// import PermContactCalendarIcon from '@material-ui/icons/';
import HomeIcon from '@material-ui/icons/Home';
import AppsIcon from '@material-ui/icons/Apps';
import InfoIcon from '@material-ui/icons/Info';


const Header = () => {
    const [value, setValue] = React.useState('recents');
  
    const handleChange = (event, newValue) => {
      setValue(newValue)
    }
    
    return (
        <section className='overflow-hidden fixed lg:bottom-10 bottom-0 w-full z-50 lg:left-[30%] '>
            <BottomNavigation value={value} onChange={handleChange} className='lg:w-2/5 rounded bg-header text-white'>
                <BottomNavigationAction href='#home' className='font' label="Home" value="Home" icon={<HomeIcon className='text-white'/>} />
                <BottomNavigationAction href='#about' className='font' label="About Me" value="About Me" icon={<InfoIcon className='text-white'/>} />
                <BottomNavigationAction href='#project' className='font' label="Project" value="Project" icon={<AppsIcon className='text-white'/>} />
                <BottomNavigationAction href='#contact' className='font' label="Contact" value="Contact" icon={<FolderIcon className='text-white'/>} />
            </BottomNavigation>
        </section>
    );
};

export default Header;